import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService, isTokenExpired } from '../services/auth.service';
import { BYPASS_AUTH } from '../../service/pincode.service';
import { Router } from '@angular/router';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(BYPASS_AUTH)) {
    return next(req);
  }

  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getToken();

  // Check if token is expired
  if (token && isTokenExpired(token)) {
    authService.clearToken && authService.clearToken();
    router.navigate(['/login']);

    return next(req); // Optionally, you can throw an error or return EMPTY
  }

  // Common headers
  const setHeaders: Record<string, string> = {
    'accept': '*/*',
    'version': '1.0',
    'authtype': 'jwt'
  };

  if (token) {
    setHeaders['jwt'] = token;
  }

  // Only set Content-Type if not FormData (for file uploads)
  if (!(req.body instanceof FormData)) {
    setHeaders['Content-Type'] = 'application/json';
  }

  const cloned = req.clone({ setHeaders });
  return next(cloned);
};
